import { render, staticRenderFns } from "./transaction-formula-detail.html?vue&type=template&id=32f5c938&scoped=true&external"
import script from "./transaction-formula-detail.js?vue&type=script&lang=js&external"
export * from "./transaction-formula-detail.js?vue&type=script&lang=js&external"
import style0 from "./transaction-formula-detail.scss?vue&type=style&index=0&id=32f5c938&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5c938",
  null
  
)

export default component.exports